import { useState } from 'react'

// Get API base URL based on hostname or env var
const getApiBaseUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  // Dev environment: localhost or app.dev.codevet.dev
  if (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === 'app.dev.codevet.dev') {
    return 'https://api.dev.codevet.dev'
  }
  // Production: app.codevet.dev
  return 'https://api.codevet.dev'
}

export default function Login() {
  const [isRedirecting, setIsRedirecting] = useState(false)

  const handleGitHubLogin = () => {
    setIsRedirecting(true)
    const apiBaseUrl = getApiBaseUrl()
    // Redirect to GitHub OAuth flow with web redirect parameter
    window.location.href = `${apiBaseUrl}/auth/github?redirect=web`
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-noir-primary py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h1 className="text-center text-3xl font-bold text-text-primary">
            CodeVet Analytics
          </h1>
          <p className="mt-2 text-center text-sm text-text-secondary">
            Sign in with your GitHub account to view your analytics dashboard
          </p>
        </div>

        <div className="mt-8">
          <button
            onClick={handleGitHubLogin}
            disabled={isRedirecting}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-border rounded-lg shadow-xs bg-noir-secondary text-text-primary hover:bg-noir-tertiary focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            aria-label="Sign in with GitHub"
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-sm font-medium">
              {isRedirecting ? 'Redirecting to GitHub...' : 'Sign in with GitHub'}
            </span>
          </button>
        </div>

        <div className="mt-6">
          <p className="text-center text-xs text-text-secondary">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  )
}
